<div class="d-flex justify-content-between align-items-center mb-4">
  <h1 class="h3 mb-0">{{ 'announcement.page.title' | translate }}</h1>
</div>

<lib-announcements-list
  [announcements]="announcements()"
  (create)="onCreate()"
  (edit)="onEdit($event)"
  (deleteAnnouncement)="onDelete($event)"
></lib-announcements-list>
